import { render, staticRenderFns } from "./MealsWeekListDate.vue?vue&type=template&id=19276c43"
import script from "./MealsWeekListDate.vue?vue&type=script&lang=js"
export * from "./MealsWeekListDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports